import React from 'react'
import { twMerge } from 'tailwind-merge'

export const ProgressValueText = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={twMerge('text-white font-semibold', className)} {...props} />
)

ProgressValueText.displayName = 'ProgressValueText'
